import qs from 'qs';

// eslint-disable-next-line no-magic-numbers
const SUCCESS_STATUSES = [ 200 ];

export default class AdminApiClient {
    constructor({ apiUrl = '', prefix = 'v1/', onResponse } = {}) {
        this.apiUrl = apiUrl;
        this.prefix = prefix;
        this.token  = '';

        this._onResponse = onResponse;
    }

    async get(url, params, asText) {
        return this.request({
            url,
            params,
            method : 'GET',
            asText
        });
    }

    async post(url, payload = {}, params = '', asText) { // eslint-disable-line
        return this.request({
            url,
            params,
            method : 'POST',
            body   : payload,
            asText
        });
    }

    async put(url, payload = {}) {
        return this.request({
            url,
            method : 'PUT',
            body   : payload
        });
    }

    async patch(url, payload = {}) {
        return this.request({
            url,
            method : 'PATCH',
            body   : payload
        });
    }

    async delete(url, payload = {}) {
        return this.request({
            url,
            method : 'DELETE',
            body   : payload,
            asText : true
        });
    }

    _formQueryString({ params }) {
        const isParamsExist = Object.keys(params).length;

        if (isParamsExist) {
            return `?${qs.stringify(params, { arrayFormat: 'comma' })}`;
        }

        return '';
    }

    _formHeader() {
        const isTokenExist = Boolean(this.token);

        if (isTokenExist) {
            return {
                'Content-Type'  : 'application/json',
                'Authorization' : `Bearer ${this.token}`
            };
        }

        return {
            'Content-Type' : 'application/json'
        };
    }

    async request({ url, method, params = {}, body, asText }) {
        const query =  this._formQueryString({ params: { ...params, token: this.token } });

        const headers = this._formHeader();

        const response = await fetch(
            `${this.apiUrl}${this.prefix}${url}${query}`,
            {
                method,
                headers,
                withCredentials : true,
                crossDomain     : false,
                body            : method !== 'GET' ? JSON.stringify(body) : undefined
            }
        );

        if (asText) {
            const text = await response.text();

            if (!SUCCESS_STATUSES.includes(response.status)) throw text; // If respones we status 400 / 404 , etc

            return text;
        }

        const json = await response.json();

        if (this._onResponse) return this._onResponse(response.status, json);

        if (!SUCCESS_STATUSES.includes(response.status)) throw json; // If respones we status 400 / 404 , etc

        return json.data;
    }

    setToken(token) {
        this.token = token;
    }

    setResponseHandler(onResponse) {
        this._onResponse = onResponse;
    }
}
